import {z} from 'zod';
import {requisitionDate} from './requisitions';
import {quantityToUnits} from './warehouseReceipts';
const money2=/^(?:0|[1-9]\d{0,11})(?:\.\d{1,2})?$/;
export const opportunityDraftSchema=z.object({
 requestId:z.string().uuid(),customerId:z.string().min(1).max(100),title:z.string().trim().min(3).max(200),
 expectedDate:requisitionDate.nullable().default(null),currency:z.string().trim().regex(/^[A-Za-z]{3}$/).transform(v=>v.toUpperCase()).default('USD'),
 amount:z.string().trim().regex(money2).nullable().default(null),notes:z.string().trim().max(2000).default(''),
});
export const opportunityUpdateSchema=opportunityDraftSchema.extend({revision:z.number().int().positive(),reason:z.string().trim().min(5).max(1000)});
export type OpportunityUpdate=z.input<typeof opportunityUpdateSchema>;
export const opportunityActionSchema=z.object({
 revision:z.number().int().positive(),action:z.enum(['qualify','win','lose','cancel']),reason:z.string().trim().min(5).max(1000),
 piId:z.string().min(1).max(100).nullable().default(null),
});
export const deliveryWaveSchema=z.object({
 id:z.string().uuid(),lineId:z.string().min(1).max(150),plannedDate:requisitionDate,
 quantity:z.string().trim().refine(v=>{try{return quantityToUnits(v)>0;}catch{return false;}}),
});
export const soWavesSchema=z.object({requestId:z.string().uuid(),soId:z.string().uuid(),expectedRevision:z.number().int().nonnegative(),expectedSourceRevision:z.number().int().positive(),reason:z.string().trim().min(5).max(1000),waves:z.array(deliveryWaveSchema).max(80)}).refine(v=>new Set(v.waves.map(w=>w.id)).size===v.waves.length,{message:'wave_quantity'});
export type OpportunityInput=z.input<typeof opportunityDraftSchema>;
export type OpportunityAction=z.input<typeof opportunityActionSchema>;
export type SoWavesInput=z.infer<typeof soWavesSchema>;
export interface SalesOpportunityDto {
 id:string;documentNo:string;customerId:string;title:string;status:'Draft'|'Qualified'|'Won'|'Lost'|'Cancelled';
 expectedDate:string|null;currency:string;amount:string|null;customerName:string;piNo:string|null;archived:boolean;createdBy:string|null;piId:string|null;notes:string;revision:number;createdAt:number;
 events:{snapshot?:unknown;action:string;reason:string;createdAt:number;createdBy:string|null}[];
}
export interface SoDeliveryWaveDto {id:string;soId:string;lineId:string;waveNo:number;plannedDate:string;quantity:string;}

export interface DeliveryScheduleDto {
 data:SoDeliveryWaveDto[];revision:number;sourceRevision:number;sourceCurrent:boolean;legacy:boolean;
 events:{id:string;revision:number;sourceRevision:number;reason:string;waves:SoDeliveryWaveDto[];createdAt:number;createdBy:string|null}[];
}
export interface OpportunitySourceOption{id:string;label:string;detail?:string;}
